import { render, staticRenderFns } from "./EventBasicInfo.vue?vue&type=template&id=5d46926d"
import script from "./EventBasicInfo.vue?vue&type=script&lang=js"
export * from "./EventBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports